<template>
  <div class="pulish-page">
    <div class="header">
			<div class="title">大攻城狮们将会热心为您的需求提供友情支持！</div>
		</div>
		<div class="main">
			<div class="top-box">
				<publish-input></publish-input>
				<publish-list ref="publishListRef"></publish-list>
			</div>
			<file-list ref="fileListRef"></file-list>
		</div>
  </div>
</template>

<script>
import PublishInput from './publish-input.vue';
import PublishList from './publish-list.vue';
import FileList from './file-list.vue';

export default {
  data() {
		return {
			
		}
	},
	components: { PublishInput, PublishList, FileList },
	methods: {
		resetPublishList() {
			this.$refs.publishListRef.currentChange(1);
		},
		resetFileList() {
			this.$refs.fileListRef.currentChange(1);
		},
		fileClick(value) {
			const { id, filepath, name } = value;
			this.$emit('fileClick', null, {
				filepath,
				id,
				name,
				name2: name,
				subcount: 0
			})
		}
	}
}
</script>

<style lang="less" scoped>
.pulish-page{
  width: 100%;
	height: 100%;
	position: relative;
	padding-top: 40px;
  .header {
		position: absolute;
		top: 0;
		width: 100%;
		left: 0;
		z-index: 99;
		font-size: 14px;
		font-weight: 500;
		color: #2f3848;
		height: 40px;
		padding: 0 14px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #d6d6d6;
		background-color: #fff;
  }
	.main{
		height: 100%;
		padding: 10px 10px 0 10px;
		display: flex;
    flex-direction: column;
	}
	.top-box{
		width: 100%;
		height: 266px;
		margin-bottom: 10px;
		display: flex;
	}
}
</style>
